/*
 Defines what is required in the project parent controller:
 @name newReview
 @description Defines the page for submitting a new review
 @requires $scope.details
 @requires $scope.isProfessional
 */

module.exports = function (bootstrap) {

    bootstrap.directive('newReview', function () {

        return {
            restrict: 'A',
            scope: false,
            template: require('directives/reviews/newReview.html'),
            controller: ['$scope', '$state', '$sce', 'services', 'coremetrics', 'pvdBrandName', 'brand', 'sessionData', 'parseProviderDetails',
                function ($scope, $state, $sce, services, coremetrics, pvdBrandName, brand, sessionData, parseProviderDetails) {

                    var key, reviewType, token;

                    //If not coming from disclaimer page, redirect to disclaimer page
                    if (!$state.params.signedDisclaimer) {
                        $state.go('providers.reviewDisclaimer', {
                            practitionerId: $state.params.practitionerId,
                            vendorId : $state.params.vendorId,
                            vendorType: $state.params.vendorType,
                            locationSequenceNumber: $state.params.locationSequenceNumber,
                            productId: $state.params.productId
                        });
                    }

                    $scope.fireCoremetrics = function (name, value, staticValue) {

                        var type = $scope.isProfessional ? 'PROVIDER' : 'FACILITY';

                        if (name && value) {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ':REVIEW ' + type + ':' + name.toUpperCase() + ' ' + value, $scope.parentConfig.categoryId);
                        } else if (staticValue) {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ':REVIEW ' + type + ':' + staticValue, $scope.parentConfig.categoryId);
                        }
                    };

                    var initialize = function () {

                        key = $scope.isProfessional($scope.details) ? $scope.details.professionalInfo.fivePartKey : $scope.details.selectedLocation.fivePartKey;

                        switch ($scope.details.type) {
                            case 'F':
                                reviewType = 'General\/Acute Care Hospital';
                                token = $scope.details.selectedLocation.fivePartKey.token;
                                break;
                            case 'D':
                                reviewType = 'Doctor';
                                token = $scope.details.professionalInfo.fivePartKey.token;
                                break;
                            case 'G':
                                reviewType = 'General\/Acute Care Hospital';
                                token = $scope.details.selectedLocation.fivePartKey.token;
                                break;
                        }
                        key.providerSuffix = key.providerSuffix || '';



                        //Put the form in scope so it can be manipulated
                        $scope.form = {
                            patientReviewForm: {}
                        };

                        $scope.staticQuestions = {};
                        $scope.formData = {};

                        $scope.displayMapping = {
                            "Comments": {
                                type: "textarea"
                            },
                            "Experience": {
                                type: "stars"
                            },
                            "Recommend": {
                                type: "affirm"
                            },
                            "Communication": {
                                type: "stars"
                            },
                            "Availability": {
                                type: "stars"
                            },
                            "Environment": {
                                type: "stars"
                            },
                            "Headline": {
                                type: "text"
                            },
                            "Screenname": {
                                type: "text"
                            },
                            "Communication: physician": {
                                type: "stars"
                            },
                            "Communication: personnel": {
                                type: "stars"
                            },
                            "Communication: follow-up care": {
                                type: "affirm"
                            },
                            "Environment: cleanliness": {
                                type: "stars"
                            },
                            "Environment: privacy": {
                                type: "stars"
                            }
                        };

                        $scope.categories = [];

                        $scope.pattern = /\/n/gi;

                        services.dpsext.getReviewQuestions().fetch({predicate_type: reviewType}).then(function (res) {

                            //If no questions are returned, redirect
                            if (!res.data.questions) {
                                $state.go('error', {
                                    status: 404,
                                    displayName: $scope.formattedName,
                                    practitionerId: $scope.details.professionalInfo.practitionerId,
                                    vendorId: $scope.details.selectedLocation.vendorId,
                                    vendorType: $state.params.vendorType,
                                    locationSequenceNumber: $scope.details.selectedLocation.locationSequenceNo
                                });
                            }

                            $scope.dynamicQuestions = parseProviderDetails.newReviewTransformQuestions(res.data.questions);
                            $scope.categories = parseProviderDetails.uniq(parseProviderDetails.newReviewTransformCategories($scope.dynamicQuestions));
                            $scope.staticQuestions = parseProviderDetails.newReviewTransformStaticCategories(res.data.questions);

                            for (var j = 0; j < $scope.dynamicQuestions.length; j++) {
                                if ($scope.dynamicQuestions[j].title === 'Recommend') {
                                    $scope.recommendKey = $scope.dynamicQuestions[j].number;
                                }
                                if ($scope.dynamicQuestions[j].title === 'Experience') {
                                    $scope.experienceKey = $scope.dynamicQuestions[j].number;
                                }
                            }

                        }, function (err) {
                            console.error(err);
                            $state.go('error', err);
                        });
                    };

                    $scope.cancel = function () {
                        if ($scope.isProfessional) {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW PROVIDER:CANCEL', $scope.parentConfig.categoryId + ':REVIEW PROVIDER');
                        } else {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW FACILITIES:CANCEL', $scope.parentConfig.categoryId + ':REVIEW FACILITIES');
                        }
                        $scope.backAction();
                    };

                    $scope.reset = function () {

                        if ($scope.isProfessional) {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW PROVIDER:RESET FORM', $scope.parentConfig.categoryId + ':REVIEW PROVIDER');
                        } else {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW PROVIDER:RESET FORM', $scope.parentConfig.categoryId + ':REVIEW FACILITIES');
                        }

                        $scope.formData = {};
                        $scope.error = '';
                        for (var i = 0; i < $scope.dynamicQuestions.length; i++) {
                            var q = $scope.dynamicQuestions[i];
                            if (q.title !== 'Recommend' && q.title !== 'Communication: follow-up care') {
                                $scope.formData[q.number] = 0;
                            } else {
                                $scope.formData[q.number] = null;
                            }
                        }

                        // Needed so that the validation errors disappear
                        $scope.form.patientReviewForm.$setPristine();
                        $scope.form.patientReviewForm.$setUntouched();
                    };

                    $scope.error = '';

                    $scope.validate = function () {

                        if ($scope.formData[$scope.experienceKey] === 0) {
                            $scope.form.patientReviewForm[$scope.experienceKey].$invalid = true;
                            $scope.form.patientReviewForm.$invalid = true;
                            $scope.form.patientReviewForm.$valid = false;
                        }

                        if ($scope.form.patientReviewForm.$invalid && $scope.form.patientReviewForm.$submitted) {
                            $scope.error = 'Please fill out all required fields.';
                        } else {
                            $scope.error = '';
                        }

                    };

                    $scope.submit = function () {

                        if ($scope.isProfessional) {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW PROVIDER:SUBMIT REVIEW', $scope.parentConfig.categoryId + ':REVIEW PROVIDER');
                        } else {
                            coremetrics.elementTag($scope.parentConfig.categoryId + ': REVIEW FACILITIES:SUBMIT REVIEW', $scope.parentConfig.categoryId + ':REVIEW FACILITIES');
                        }

                        var data = [],
                            copied;

                        $scope.validate();

                        if ($scope.form.patientReviewForm.$valid) {

                            copied = angular.copy($scope.formData);
                            delete copied.terms;

                            for (var key in copied) {
                                if ((copied[key] === 0 || !copied[key]) && key !== $scope.recommendKey.toString()) {
                                    delete copied[key];
                                } else {
                                    data.push({"number": key, "value": copied[key].toString()});
                                }
                            }

                            services.dpsext.createMemberReview().create({
                                predicate_token: token,
                                predicate_type: reviewType,
                                questions: JSON.stringify(data),
                                reviewer_token: sessionData.memberInfo.bvUserId
                            }).then(function (res) {
                                if (res.data.result_code === 'S') {
                                    $state.go('providers', {
                                        submitted: true,
                                        isOpenPR: true,
                                        practitionerId: $state.params.practitionerId,
                                        vendorId: $state.params.vendorId,
                                        vendorType: $state.params.vendorType,
                                        locationSequenceNumber: $state.params.locationSequenceNumber,
                                        productId: $state.params.productId,
                                        brandName: pvdBrandName.getCPDBrandNameBySharedBrandCode(brand.current.sharedBrandCode)
                                    });
                                } else {
                                    if (res.data.result_msg && res.data.result_msg === 'FAILED') {
                                        $scope.error = res.data.questions_result_msg || 'The form submission failed.';
                                    } else {
                                        $scope.error = res.data.result_msg || 'The form submission failed.';
                                    }
                                }
                            }, function (error) {
                                $state.go('error', {
                                    status: 404,
                                    details: error,
                                    displayName: $scope.formattedName,
                                    practitionerId: $state.params.practitionerId,
                                    vendorId: $state.params.vendorId,
                                    vendorType: $state.params.vendorType,
                                    locationSequenceNumber: $state.params.locationSequenceNumber,
                                    productId: $state.params.productId
                                });
                            });
                        }
                    };

                    initialize();

                    //TODO - do we need this watchgroup?
                    $scope.$watchGroup(['formData', 'form'], function (newVal) {
                        if(newVal[0] && newVal[1]){
                            $scope.validate();
                        }
                    });

                }]
        };

    });

};